/**
 * Created by Jan Bradac on 1.7.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * A namespace for objects, methods and classes related to forms and inputs (submission and manipulation)
     *
     * @memberOf Lfl
     */
    Lfl.Forms;
    (function (Forms, $, undefined) {

    }(Lfl.Forms = Lfl.Forms || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));